
export default class soloCategoryFilter {
    constructor(item) {
        this.item = item;
        this.selectedItem = '';
    }

    init() {

        let hideAllItems = () => {
            this.item
                    .querySelectorAll(".item")
                    .forEach(item => {
                        item.classList.remove('show');                    
                    });
        }

        let showAllItems = () => {
            this.item
                    .querySelectorAll(".item")
                    .forEach(item => {
                        item.classList.add('show');                    
                    });
        }

        let filterItems = () => {
            hideAllItems();
            this.item
                .querySelectorAll(".item")
                .forEach(item => {
                    let selectedValue = item.dataset.value;
                    if(this.selectedItem == selectedValue){
                        item.classList.add('show');
                    }else{
                        item.classList.remove('show');
                    }                     
                });               
        }

        let selectItem = (selectedVal) => {           
            this.selectedItem = selectedVal;
            filterItems();
        }

        $(".filter-item").on('select2-loaded', function (e) {
            $('.filter-item').val($('#yourSelect2 option:eq(1)').val()).trigger('change');
        });

        $('.filter-item').on('change', function() {
            let selectedVal = $(this).children("option:selected").val();
            if (selectedVal == 'all'){
                showAllItems();
            }else{
                selectItem(selectedVal);
            }
            
        });
    }
}
